// const rollbar = require('rollbar');


// const rollbar = new Rollbar({
//   accessToken: 'd4083c339e3d4b189f08beb10fd73d9c',
//   captureUncaught: true,
//   captureUnhandledRejections: true,
// });

export function handleError(message) {
  console.error(message);
  console.warn(`Error in env: ${process.env.NODE_ENV}`);
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
    window.Rollbar.error(message);
  }
}

export function checkIfJson(itemParam) {
  let item = typeof itemParam !== 'string'
    ? JSON.stringify(itemParam)
    : itemParam;

  try {
    item = JSON.parse(item);
  } catch (e) {
    handleError(e);
    return null;
  }

  if (typeof item === 'object' && item !== null) {
    return itemParam;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/errorHandler.js